import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    document.addEventListener('click', this.#handleTyraPairing);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    document.removeEventListener('click', this.#handleTyraPairing);
  }

  #handleTyraPairing = async (e) => {
    const btn = e.target.closest('.tyra-size');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    const all = document.querySelectorAll('.tyra-size');
    const label = btn.textContent;
    all.forEach((b) => (b.disabled = true));
    btn.innerHTML = '···';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(btn.dataset.vid), quantity: 1 }),
      });
      if (!res.ok) throw new Error('add failed');

      const page = await fetch(window.location.pathname + window.location.search);
      const doc = new DOMParser().parseFromString(await page.text(), 'text/html');

      const fresh = doc.querySelector('.cart-drawer__inner');
      const live = this.querySelector('.cart-drawer__inner');
      if (!fresh || !live) throw new Error('no drawer');
      live.innerHTML = fresh.innerHTML;

      const freshBubble = doc.querySelector('.cart-bubble');
      document.querySelectorAll('.cart-bubble').forEach((b) => {
        if (freshBubble && !this.contains(b)) b.innerHTML = freshBubble.innerHTML;
      });

      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
    } catch (err) {
      console.error(err);
      btn.textContent = label;
      all.forEach((b) => (b.disabled = false));
    }
  };

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) this.showDialog();
  };

  open() {
    this.showDialog();
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}